// extracted by mini-css-extract-plugin
export var addToCartButton = "_r5-b";
export var arrowButtonContainer = "_r5-9";
export var arrowButtonIcon = "_r5-a";
export var carouselArrowButton = "_r5-6";
export var carouselElementContainer = "_r5-1";
export var left = "_r5-7";
export var productDisplayCarouselContainer = "_r5-0";
export var productTileContainer = "_r5-2";
export var productTileImage = "_r5-4";
export var productTileImageContainer = "_r5-3";
export var productTileTitle = "_r5-5";
export var right = "_r5-8";
export var sliderOverflow = "_r5-c";